import i18n from '@/lang'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import pinia from '@/stores'

export function registerPlugins (app) {
  app
    .use(i18n)
    .use(vuetify)
    .use(router)
    .use(pinia)

  app
    .provide('app', app)
    .provide('i18n', i18n)
    .provide('router', router)
}
